import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}

interface JournalPublicationItem {
  sno: number;
  title: string;
  authors: string[];
  journalName: string;
  details: string;
}

interface ConferencePublicationItem {
  sno: number;
  title: string;
  authors: string[];
  conferenceName: string;
  organization: string;
  date: string;
  details: string;
}

interface BookAuthoredItem {
  sno: number;
  author: string;
  title: string;
  publisher: string;
  isbn: string;
  publishedOn: string;
}
interface AlumniItem {
  sno: number;
  name: string;
  batch: string;
  designation: string;
  company: string;
  image: string;
}
interface MouItem {
  sno: number;
  activity: string;
  organization: string;
  outcome: string;
}
interface ActivityItem {
  sno: number;
  activity: string;
  resourcePerson: string;
  outcome: string;
}
interface SpecializationItem {
  sno: number;
  name: string;
}
interface IndustrialVisitItem {
  sno: number;
  title: string;
  date: string;
  place: string;
  image: string;
  description: string;
}
@Component({
  selector: 'app-home-page-six',
  templateUrl: './home-page-six.component.html',
  styleUrls: ['./home-page-six.component.scss']
})
export class HomePageSixComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Master of Business Administration';
  establishedYear = '2023';
  programmeSummary = '1 PG Programme';
  contactEmail = 'directormba@fmcet.ac.in';

 admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
tabs: DepartmentTab[] = [
  { id: 'tab1', label: 'About the Department' },
  { id: 'tab2', label: 'Vision & Mission' },
  { id: 'tab3', label: "PEO's" },
  { id: 'tab4', label: 'POs & PSOs' },
  { id: 'tab14', label: 'Programme Offered' },
  
  { id: 'tab6', label: 'Association & Club Activities' },
  { id: 'tab7', label: "MoU's" },
  
  { id: 'tab9', label: 'Industrial Visit' },
  
  { id: 'tab11', label: 'Alumni' },
  
  
  { id: 'tab15', label: 'Research' }
];
  aboutParagraphs: string[] = [
    'The Department of Management Studies established in 2023 is committed to outstanding value based quality education, research, executive education, consultancy and strong corporate as well as international linkages.',
    'Constituted with the vision of offering transformational education focussing on entrepreneurship and thought leadership, the school nurtures and develops the best of managerial talent who create sustainable value engaging in a variety of initiatives of social and economic benefit to this nation.',
    'The inspirational and applied learning environment educates, equips and inspires students to exhibit value based leadership, entrepreneurship and contemporary research.',
    'The department fosters greater inclusion by promoting alumni interaction, industry interface and international relations in its progression. An empathetic approach to inclusive education by empowering the hearing, speech and visually impaired students is the forte of the school resulting in invaluable improvement in standards and quality of life for differently-abled individuals.',
    'The department embodies change-maker values, supporting and motivating every student to unlock their full potential and achieve their ambitions. The spirit of pragmatic enquiry and in depth analysis of the dynamics of business has continued to this day. The programs are designed to bring out and nurture the leadership and organizing skills of the future managers. At DOMS, apart from the regular curriculum, there is an emphasis on guidance and counselling that enables the development of managerial excellence.'
  ];

  quickFacts: FactItem[] = [
    {
      title: 'Established',
      value: '2023'
    },
    {
      title: 'Academic Focus',
      value: 'Value based business education, research, executive education, consultancy, and corporate linkages'
    },
    {
      title: 'Learning Vision',
      value: 'Transformational education with focus on entrepreneurship and thought leadership'
    },
    {
      title: 'Student Development',
      value: 'Leadership, inclusion, guidance, counselling, and managerial excellence'
    }
  ];

  visionText =
    'To be a globally renowned department for providing transformational business education with distinct focus on entrepreneurship and thought leadership to benefit organizations and society.';

  missionPoints: string[] = [
    'To provide a diligent academic experience for ethical, sustainable and inclusive business practices.',
    'To develop principled and innovative leaders who can make a difference in the global arena.',
    'To institute a dynamic learning and research environment promoting knowledge creation.'
  ];

  peos: string[] = [
    'To have a thorough understanding of the core aspects of the business.',
    'To provide the learners with the management tools to identify, analyze and create business opportunities as well as solve business problems.',
    'To prepare them to have a holistic approach towards management functions.',
    'To inspire and make them practice ethical standards in business.'
  ];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'PO 1',
      description: 'Apply knowledge of management theories and practices to solve business problems.'
    },
    {
      title: 'PO 2',
      description: 'Foster analytical and critical thinking abilities for data-based decision making.'
    },
    {
      title: 'PO 3',
      description: 'Develop value-based leadership ability and entrepreneurial competence.'
    },
    {
      title: 'PO 4',
      description: 'Demonstrate effective communication, teamwork, and professional ethics in organizational settings.'
    },
    {
      title: 'PO 5',
      description: 'Understand global business environment, sustainability, and inclusive management practices.'
    }
  ];

  programSpecificOutcomes: OutcomeItem[] = [
    {
      title: 'PSO 1',
      description: 'Build managerial competence to analyze business opportunities and provide strategic solutions.'
    },
    {
      title: 'PSO 2',
      description: 'Develop entrepreneurial mindset and leadership skills for sustainable organizational growth.'
    },
    {
      title: 'PSO 3',
      description: 'Apply contemporary management tools and research orientation in real-world business scenarios.'
    }
  ];

  programmes: ProgrammeItem[] = [
    {
      sno: 1,
      name: 'Master of Business Administration',
      duration: '2 Years'
    }
  ];

  journalPublications: JournalPublicationItem[] = [
    {
      sno: 1,
      title: 'A study on Sustainable Growth of Entrepreneurship in Medical Tourism in India: A Holistic Approach',
      authors: ['Dr. G. Dhinesh'],
      journalName: 'International Journal of Environmental Sciences',
      details: 'Indexed by Scopus – ISSN: 2229-7359 – Vol. 11 No. 21S (2025) – August 2025'
    },
    {
      sno: 2,
      title: 'A study on Concept of Green Marketing in India',
      authors: ['Dr. G. Dhinesh'],
      journalName: 'ACADEMICIA – An International Multidisciplinary Research Journal',
      details: 'ISSN: 2249-7137 – Vol. 15 Issue – March 2025 – SJIF 2022-8.252'
    },
    {
      sno: 3,
      title: 'A study on investment behavior among information technology professionals',
      authors: ['Dr. G. Dhinesh'],
      journalName: 'International Journal of Humanities, Law and Social Sciences',
      details: 'ISSN: 2348-8301 – Vol. IX, Issue II No. 6: 2022'
    },
    {
      sno: 4,
      title: 'Growth and development of health insurance',
      authors: ['Dr. G. Dhinesh'],
      journalName: 'Journal of The Asiatic Society of Mumbai',
      details: 'ISSN: 0972-0766 – Vol. XCV No. 42, 2022'
    },
    {
      sno: 5,
      title: 'A study on financial performance of select Pharma companies in India using Z-Score model',
      authors: ['G. Dhinesh'],
      journalName: 'Asian Journal of Research in Social Sciences and Humanities',
      details: 'ISSN: 2249-7315 – Vol. 6 No. 11 – November 2016'
    },
    {
      sno: 6,
      title: 'A study on ratio analysis of select CNX pharma stocks',
      authors: ['G. Dhinesh'],
      journalName: 'Indian Journal of Applied Research',
      details: 'ISSN: 2249-555X – Vol. 4 – Issue 8 – August 2014'
    }
  ];

  conferenceRecords: ConferencePublicationItem[] = [
    {
      sno: 1,
      title: 'Customer Centric Management: Innovations in the Banking Industry',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference',
      organization: 'Fatima Michael College of Engineering and Technology, Madurai',
      date: '30.05.2025',
      details: 'Presented in an International Conference organized by Fatima Michael College of Engineering and Technology, Madurai.'
    },
    {
      sno: 2,
      title: 'AI Driven innovation in HRM',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference',
      organization: 'Fatima Michael College of Engineering and Technology, Madurai',
      date: '30.05.2025',
      details: 'Presented in an International Conference organized by Fatima Michael College of Engineering and Technology, Madurai.'
    },
    {
      sno: 3,
      title: 'Digital Marketing',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference',
      organization: 'Fatima Michael College of Engineering and Technology, Madurai',
      date: '30.05.2025',
      details: 'Presented in an International Conference organized by Fatima Michael College of Engineering and Technology, Madurai.'
    },
    {
      sno: 4,
      title: 'Digital Management',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference',
      organization: 'Fatima Michael College of Engineering and Technology, Madurai',
      date: '30.05.2025',
      details: 'Presented in an International Conference organized by Fatima Michael College of Engineering and Technology, Madurai.'
    },
    {
      sno: 5,
      title: 'Digital Transformation and its impact on Organization',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference',
      organization: 'Fatima Michael College of Engineering and Technology, Madurai',
      date: '30.05.2025',
      details: 'Presented in an International Conference organized by Fatima Michael College of Engineering and Technology, Madurai.'
    },
    {
      sno: 6,
      title: 'A Study on Green Marketing',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'National Seminar on Revolutionizing Commerce: Applications of Artificial Intelligence in Business (NSAAIB – 2K25)',
      organization: 'P.S.Y Arts and Science College (Co-Ed), Arasanoor – 630 562',
      date: '05.03.2025',
      details: 'Presented in a National Seminar on “Revolutionizing Commerce: Applications of Artificial Intelligence in Business” (NSAAIB – 2K25).'
    },
    {
      sno: 7,
      title: 'A Study on Recent Trends in Classroom Pedagogies',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference on Emerging Trends in Engineering & Technology',
      organization: 'Pandian Saraswathi Yadav Engineering College, Sivagangai Dist.',
      date: '26.04.2024 to 27.04.2024',
      details: 'Presented in a two days International Conference on Emerging Trends in Engineering & Technology.'
    },
    {
      sno: 8,
      title: 'Financial Information Influencing Commercial Bank’s Profitability',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference on Commerce and Management in the Digital Age, Trends, Challenges and Innovations',
      organization: 'American College, Madurai',
      date: '05.01.2024 to 06.01.2024',
      details: 'Presented in a two days International Conference on Commerce and Management in the Digital Age, Trends, Challenges and Innovations.'
    },
    {
      sno: 9,
      title: 'A Study of attitude of the passengers towards rail transport in Madurai City',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference on Emerging Trends in Science, Engineering and Technology',
      organization: 'Fatima Michael College of Engineering & Technology, Madurai',
      date: '28.06.2023',
      details: 'Presented in an International Conference on Emerging Trends in Science, Engineering and Technology.'
    },
    {
      sno: 10,
      title: 'Impact on Non – Performing Assets – A Special reference to Co-operative banks in Madurai District',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference on Emerging Trends in Science, Engineering and Technology',
      organization: 'Fatima Michael College of Engineering & Technology, Madurai',
      date: '28.06.2023',
      details: 'Presented in an International Conference on Emerging Trends in Science, Engineering and Technology.'
    },
    {
      sno: 11,
      title: 'Leadership quality of middle level management',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference on Contemporary Emerging Trends in Management',
      organization: 'Anna University of Technology, Madurai',
      date: '13.02.2012 to 14.02.2012',
      details: 'Presented in a two days International Conference on Contemporary Emerging Trends in Management.'
    },
    {
      sno: 12,
      title: 'Small scale entrepreneurs in Madurai',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'National Conference on Entrepreneurship and Management',
      organization: 'Anna University of Technology, Madurai',
      date: '18.03.2011',
      details: 'Presented in a one-day National Conference on Entrepreneurship and Management.'
    },
    {
      sno: 13,
      title: 'Use of Simulation in Inventory Management',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'International Conference on Operational Research for Urban and Rural Development',
      organization: 'Thiagarajar College of Engineering, Madurai',
      date: '15.12.2010 to 17.12.2010',
      details: 'Presented in a three days International Conference on Operational Research for Urban and Rural Development.'
    },
    {
      sno: 14,
      title: 'Knowledge Management',
      authors: ['Dr. G. Dhinesh'],
      conferenceName: 'National Conference on Information Technology and Management',
      organization: 'PSNA College of Engineering & Technology, Dindigul',
      date: '03.04.2009',
      details: 'Presented in a one day National Conference on Information Technology and Management.'
    },
    {
      sno: 15,
      title: 'The Impact of Machine Learning on Financial Forecasting and Market Trends',
      authors: ['Dr. S. Vijay Mallikraj'],
      conferenceName: 'International Conference ICT in Business, Industry and Government',
      organization: 'IEEE, Madhya Pradesh',
      date: '12.12.2025',
      details: 'Presented in the international conference ICT in Business, Industry and Government. Indexed in IEEE Xplore.'
    },
    {
      sno: 16,
      title: 'AI-Powered Customer Segmentation: Enhancing Targeted Marketing Strategies through Machine Learning',
      authors: ['Dr. S. Vijay Mallikraj'],
      conferenceName: 'International Conference ICT in Business, Industry and Government',
      organization: 'IEEE, Madhya Pradesh',
      date: '12.12.2025',
      details: 'Presented in the international conference ICT in Business, Industry and Government. Indexed in IEEE Xplore.'
    }
  ];

  booksAuthored: BookAuthoredItem[] = [
    {
      sno: 1,
      author: 'Dr. G. Dhinesh',
      title: 'Financial Management',
      publisher: 'Thakur Publication, Chennai',
      isbn: '9789372901931',
      publishedOn: 'February 2026'
    }
  ];
alumniRecords: AlumniItem[] = [
  {
    sno: 1,
    name: 'Lavanya S',
    batch: '2023 - 2025',
    designation: 'Process Developer',
    company: 'Genpact, Madurai',
    image: 'assets/img/mba/lavanya-s.png'
  },
  {
    sno: 2,
    name: 'Roshna M',
    batch: '2023 - 2025',
    designation: 'HR Executive',
    company: 'KP Corporate Solution, Madurai',
    image: 'assets/img/mba/roshna-m.jpeg'
  },
  {
    sno: 3,
    name: 'Muthu Selvam V',
    batch: '2023 - 2025',
    designation: 'Voice Process Officer',
    company: 'Reliance Jio Infocom Limited, Mumbai',
    image: 'assets/img/mba/muthu-selvam-v.jpeg'
  },
  {
    sno: 4,
    name: 'Yamini R',
    batch: '2023 - 2025',
    designation: 'Project Reviewer & Event Management Coordinator',
    company: 'Thiagarajar School of Management',
    image: 'assets/img/mba/yamini-r.jpeg'
  }
];
mous: MouItem[] = [
  {
    sno: 1,
    activity: 'MOU (24.09.2025)',
    organization: 'I Square Financial Services, Madurai',
    outcome:
      'Through the MOU students were able to develop awareness about financial literacy and were encouraged to make informed investment decisions in the future.'
  }
];
associationActivities: ActivityItem[] = [
  {
    sno: 1,
    activity: 'MICHAEL BAZAAR 2K23 – A Shopping Festival (04.11.2023)',
    resourcePerson: 'Department of Management Studies & Entrepreneurship Development Cell',
    outcome: 'The program motivated students to develop both entrepreneurial and marketing competencies.'
  },
  {
    sno: 2,
    activity: 'Savings and Investment Awareness Program (24.11.2023)',
    resourcePerson: 'Mr. R. Rajesh Babu, Skill Trainer, Bombay Stock Exchange',
    outcome: 'The Savings and Investment Awareness Program enabled students to develop a strong foundation in financial literacy, particularly in understanding the importance of savings and informed investment decisions.'
  },
  {
    sno: 3,
    activity: 'Protect Your Business by Learning Ethical Hacking (17.04.2024)',
    resourcePerson: 'Mrs. V. Gayathri, Assistant Professor, Department of Information Technology, Virudhunagar',
    outcome: 'The programme helped students understand the importance of cybersecurity and ethical hacking in protecting business data and digital assets.'
  },
  {
    sno: 4,
    activity: 'MICHAEL BAZAAR 2K24 – A Shopping Festival (08.11.2024)',
    resourcePerson: 'Department of Management Studies & Entrepreneurship Development Cell',
    outcome: 'The event enhanced students’ entrepreneurial skills, teamwork, sales abilities, and practical business management experience.'
  },
  {
    sno: 5,
    activity: 'Awareness Program on Incubation Centre (03.01.2025)',
    resourcePerson: 'P. Sebin Sunny, CEO, TCE Technology Business Incubator, Thiagarajar College of Engineering',
    outcome: 'The programme created awareness among students about incubation support, startup guidance, and opportunities for transforming ideas into ventures.'
  },
  {
    sno: 6,
    activity: 'Achieving Problem–Solution Fit and Product–Market Fit (26.02.2025)',
    resourcePerson: '1. Mr. R. Niveth, Director  2. Mr. T. Ashok Kumar, Chief Executive Officer, Priya Enterprises, SR Beverages (Ko Goli Soda), Madurai',
    outcome: 'The session enabled students to understand how to identify customer needs and align products effectively with market demand.'
  },
  {
    sno: 7,
    activity: 'Availability of Financial Resources for Entrepreneurs (14.03.2025)',
    resourcePerson: 'Dr. J. Asir Abraham, Proprietor, Malligai Foods, Ramnad',
    outcome: 'The programme provided students with knowledge about various financial resources and funding opportunities available for entrepreneurs.'
  },
  {
    sno: 8,
    activity: 'How to Plan for Start-up by the Legal and Ethical Steps (18.03.2025)',
    resourcePerson: 'Dr. G. Dinesh Kumar, Founder and CEO, Tech Buds Solution, Madurai',
    outcome: 'The programme gave students an understanding of the legal procedures and ethical responsibilities involved in starting a business.'
  },
  {
    sno: 9,
    activity: 'MICHAEL BAZAAR 2K25 – A Shopping Festival (08.10.2025)',
    resourcePerson: 'Department of Management Studies & Entrepreneurship Development Cell',
    outcome: 'The event offered practical exposure to entrepreneurship by developing students’ skills in marketing, planning, leadership, and customer handling.'
  },
  {
    sno: 10,
    activity: 'Awareness about Entrepreneurs (26.08.2025)',
    resourcePerson: 'Dr. N. Rajesh Kumar, Professor, MBA, SMCET, Kalayarkovil',
    outcome: 'The programme inspired students to understand entrepreneurial qualities, opportunities, and the importance of innovation in business creation.'
  },
  {
    sno: 11,
    activity: 'Awareness about Financial Investment (24.09.2025)',
    resourcePerson: 'Mr. R. Rajan, Managing Partner, I Square Financial Investment, Madurai',
    outcome: 'The programme improved students’ understanding of financial planning, savings, and smart investment practices for future financial security.'
  },
  {
    sno: 12,
    activity: 'Investment Awareness Program (20.11.2025)',
    resourcePerson: 'Mr. K. Avinash, NSE, Deputy Manager, Common Investor Service Centre, Madurai',
    outcome: 'The programme enhanced students’ awareness of investment options, financial decision-making, and the role of investment in wealth creation.'
  }
];
specializationsOffered: SpecializationItem[] = [
  {
    sno: 1,
    name: 'Business Analytics'
  },
  {
    sno: 2,
    name: 'Human Resource'
  },
  {
    sno: 3,
    name: 'Finance'
  },
  {
    sno: 4,
    name: 'Marketing'
  }
];
industrialVisits: IndustrialVisitItem[] = [
  {
    sno: 1,
    title: 'Industrial Visit to Hatsun Agro Products',
    date: '06.02.2026',
    place: 'Hatsun Agro Product Ltd, Vadipatti, Madurai',
    image: 'assets/img/mba/industrial-visit/hatsun-vadipatti.jpg',
    description:
      'The Department of Management Studies organized an industrial visit for first MBA students to Hatsun Agro Product Ltd, Vadipatti, Madurai. Students learned about the company’s history, dairy brands, milk procurement, processing, quality control, packaging, distribution, supply chain management, hygiene standards, and the use of modern technology in dairy production. The visit provided practical exposure to operations management, quality assurance, and organizational practices.'
  }
];
  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}